// extracted by mini-css-extract-plugin
module.exports = {"distinction":"_f9ac9ec2","copy":"_bf65fd75","icon":"_d370dd1b","tooltipText":"_8deb1ff8"};